import React from 'react';
import styled from 'styled-components';

const Dot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0aa15b;
  flex-shrink: 0;
`;

const EmptyDot = styled(Dot)`
  background: transparent;
  border: 1px solid #ddd;
`;

function LiveDot({ live, title }) {
  return live ? (
    <Dot title={title || 'Live — a PUBLISHED version is serving production'} />
  ) : (
    <EmptyDot title={title || 'Not live — no PUBLISHED version'} />
  );
}

export default LiveDot;
